import classnames from 'classnames';
import { NoDataComponent } from '@/shared/ui';
import DeviceEditStripBox from './deviceEditStripBox';
import DeviceStripEvents from './deviceStripEvents';
import DeviceStripImageViewer from './stripImageViewer';
import StripsDeviceActionButton from './stripsDeviceActionButton';
import useDeviceEventWrapper from './useDeviceEventWrapper';

export type DeviceEventWrapperProps = {
  reportData?: any;
  isActive?: boolean;
};

/**
 * Layout for the device events half of the strips management tab. useDeviceEventWrapper supplies the tab key, active action button, ECG data map, study id and timezone; an empty result set is replaced by a refresh prompt, otherwise the action bar, thumbnail grid, edit pane and strip image viewer are laid out together, with the header hidden when the tab header is off.
 *
 * @param props - Wrapper props carrying the report data and whether this tab is currently active.
 * @returns The rendered device event layout, or the no-data refresh prompt.
 */
const DeviceEventWrapper = ({ reportData, isActive }: DeviceEventWrapperProps) => {
  const {
    keyRecoil,
    activeButton,
    ecgDataMap,
    studyId,
    timezoneOffset,
    loading,
    isShowTabHeader,
    onClickRefreshEmptyData,
    isEmptyData,
  } = useDeviceEventWrapper({ reportData, isActive });

  return (
    <div
      className={classnames(
        'rhythm-event-content strip-management-content',
        !isShowTabHeader ? 'is-hide-header' : '',
      )}
    >
      {isEmptyData ? (
        <NoDataComponent
          hasButton
          buttonName="Refresh"
          onClick={onClickRefreshEmptyData}
          className="strip-no-data-component"
          isSaving={loading}
        />
      ) : (
        <>
          <StripsDeviceActionButton
            keyRecoil={keyRecoil}
            activeButton={activeButton}
            studyData={reportData?.study}
          />
          <DeviceStripEvents
            activeButton={activeButton}
            studyId={studyId}
            reportData={reportData}
            keyRecoil={keyRecoil}
            isActive={isActive}
          />

          <div id="strip-info" className="strip-events-content-container --min-width-strip-event">
            <div className="event-select-ecg-viewer-wrapper">
              <DeviceEditStripBox keyRecoil={keyRecoil} isActive={isActive} />
              <DeviceStripImageViewer
                reportData={reportData}
                ecgDataMap={ecgDataMap}
                timezoneOffset={timezoneOffset}
                activeButton={activeButton}
                keyRecoil={keyRecoil}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeviceEventWrapper;
